import qs from 'qs';
import { axiosAPI } from '@/axios';

const loadGalleries = (filter) => {
  const query = qs.stringify(filter, { addQueryPrefix: true, skipNulls: true });
  if (query) {
    return axiosAPI.get(`/galleries${query}`);
  }
  return axiosAPI.get('/galleries');
};

const loadGalleryById = (galleryId) => {
  return axiosAPI.get(`/galleries/${galleryId}`);
};

const newGallery = (gallery) => {
  return axiosAPI.post('/galleries', gallery);
};

const deleteGalleryById = (galleryId) => {
  return axiosAPI.delete(`/galleries/${galleryId}`);
};

const updateGalleryById = (galleryId, gallery) => {
  return axiosAPI.put(`/galleries/${galleryId}`, gallery);
};

const saveGallery = (galleryId, gallery) => {
  return axiosAPI.put(`/galleries/${galleryId}`, gallery);
};

const batchCreate = (galleryId, items) => {
  return axiosAPI.post(`/galleries/${galleryId}/items/batch-create`, items);
};

const saveOrder = (galleryId, itemIds) => {
  return axiosAPI.put(`/galleries/${galleryId}/order`, itemIds);
};

const updateImageMetaByGalleryId = (galleryId, imageId, meta) => {
  return axiosAPI.put(`/galleries/${galleryId}/items/${imageId}`, meta);
};

const deleteImageByGalleryId = (galleryId, imageId) => {
  return axiosAPI.delete(`/galleries/${galleryId}/items/${imageId}`);
};

// Modal
const loadGalleriesByPage = (page) => {
  return axiosAPI.get(`/galleries?limit=6&page=${page}`);
};

const searchGalleryByName = (galleryName) => {
  return axiosAPI.get(`/galleries?limit=6&q=${galleryName}`);
};

export {
  loadGalleries,
  loadGalleryById,
  newGallery,
  deleteGalleryById,
  updateGalleryById,
  saveGallery,
  batchCreate,
  saveOrder,
  updateImageMetaByGalleryId,
  deleteImageByGalleryId,
  loadGalleriesByPage,
  searchGalleryByName,
};
